import { useFieldArray } from 'react-hook-form'
import type { UseFormReturn } from 'react-hook-form'
import { CardHeader, Button, Alert } from '@orientamos/ui'
import { Plus, Trash2, User } from 'lucide-react'
import type { IntakeFormData } from '@orientamos/shared'
import { PartyForm } from '../PartyForm'

interface Step4Props {
  form: UseFormReturn<IntakeFormData>
}

export function Step4Guarantors({ form }: Step4Props) {
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'guarantors',
  })

  const addGuarantor = () => {
    if (fields.length >= 3) return

    append({
      personType: 'natural',
      firstName: '',
      lastName: '',
      idNumber: '',
      idIssuedAt: '',
      profession: '',
      phone: '',
      address: '',
      city: 'Medellin',
      email: '',
      invoiceEmail: '',
      role: 'guarantor',
      sortOrder: fields.length,
      banking: null,
      documents: null,
      dataAuthorizationAccepted: false,
      referenceCheckAuthorized: false,
    })
  }

  return (
    <div className="space-y-8">
      <CardHeader
        title="Deudores Solidarios"
        description="Agrega hasta 3 deudores solidarios (codeudores) para el contrato. Este paso es opcional."
      />

      {fields.length === 0 && (
        <Alert variant="info">
          No hay deudores solidarios agregados. Puedes continuar sin agregar o agregar hasta 3
          codeudores.
        </Alert>
      )}

      {fields.map((field, index) => (
        <div
          key={field.id}
          className="relative pt-6 pb-8 border-t border-neutral-200 first:border-t-0 first:pt-0"
        >
          <div className="absolute top-6 right-0 first:top-0">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => remove(index)}
              className="text-danger-600 hover:text-danger-700 hover:bg-danger-50"
            >
              <Trash2 className="w-4 h-4 mr-1" />
              Eliminar
            </Button>
          </div>

          <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-primary-700">
              <User className="w-4 h-4" />
            </div>
            <span className="font-medium text-neutral-900">Deudor Solidario {index + 1}</span>
          </div>

          <PartyForm
            form={form}
            basePath={`guarantors.${index}`}
            title=""
            description=""
            showBanking={false}
            personTypeToggle={true}
          />
        </div>
      ))}

      {fields.length < 3 && (
        <div className="pt-4">
          <Button type="button" variant="outline" onClick={addGuarantor}>
            <Plus className="w-4 h-4 mr-1" />
            Agregar Deudor Solidario
          </Button>
        </div>
      )}

      {fields.length >= 3 && (
        <Alert variant="warning">
          Has alcanzado el maximo de 3 deudores solidarios permitidos.
        </Alert>
      )}
    </div>
  )
}
